var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_475_238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 9.8565C11.2812 12.9988 8.75578 15.5461 5.6407 15.5461C2.52561 15.5461 0 12.9982 0 9.8565C0 6.71481 2.52542 4.16675 5.6407 4.16675C8.75598 4.16675 11.2812 6.71423 11.2812 9.8565Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4691 9.85646C17.4691 12.8142 16.2064 15.2129 14.6487 15.2129C13.0911 15.2129 11.8284 12.8142 11.8284 9.85646C11.8284 6.8987 13.0909 4.5 14.6485 4.5C16.2062 4.5 17.4689 6.89793 17.4689 9.85646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.85592C20 12.5053 19.556 14.6545 19.0081 14.6545C18.4602 14.6545 18.0164 12.5059 18.0164 9.85592C18.0164 7.20591 18.4604 5.05737 19.0081 5.05737C19.5558 5.05737 20 7.20572 20 9.85592Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_475_238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.cc7b8c35.svg";
export { ForwardRef as ReactComponent };